/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserExcludingFcmMessageIdFcmTokenWithRelations } from './userExcludingFcmMessageIdFcmTokenWithRelations';
import { RequisitionCommentTypeExcludingFcmMessageIdFcmTokenWithRelations } from './requisitionCommentTypeExcludingFcmMessageIdFcmTokenWithRelations';


/**
 * (tsType: Omit<RequisitionCommentWithRelations, \'fcmMessageId\' | \'fcmToken\'>, schemaOptions: { includeRelations: true, exclude: [ \'fcmMessageId\', \'fcmToken\' ] })
 */
export interface RequisitionCommentExcludingFcmMessageIdFcmTokenWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    requisitionId: string;
    comment?: string;
    commentTypeId?: string;
    userId?: number;
    commentType?: RequisitionCommentTypeExcludingFcmMessageIdFcmTokenWithRelations;
    user?: UserExcludingFcmMessageIdFcmTokenWithRelations;
}

